import RaisedPage from '@atoms/RaisedPage';
import Header from '@components/layout/header';
import Wrestlers from '@pages/Wrestlers/Wrestlers';

export default function Dashboard() {
    return (
        <>
            <Header pageTitle={'Dashboard'} />
            <RaisedPage>
                <Wrestlers />
            </RaisedPage>
        </>
    );
}
